
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/submit-request",
      function () {
        return require("private-next-pages/submit-request/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/submit-request"])
      });
    }
  